/*
 *
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TenantIntegrationTemplateCategory from './tenant-integration-template-category';
import TenantIntegrationTemplateCategoryDetail from './tenant-integration-template-category-detail';
import TenantIntegrationTemplateCategoryUpdate from './tenant-integration-template-category-update';
import TenantIntegrationTemplateCategoryDeleteDialog from './tenant-integration-template-category-delete-dialog';

const TenantIntegrationTemplateCategoryRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TenantIntegrationTemplateCategory />} />
    <Route path="new" element={<TenantIntegrationTemplateCategoryUpdate />} />
    <Route path=":id">
      <Route index element={<TenantIntegrationTemplateCategoryDetail />} />
      <Route path="edit" element={<TenantIntegrationTemplateCategoryUpdate />} />
      <Route path="delete" element={<TenantIntegrationTemplateCategoryDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TenantIntegrationTemplateCategoryRoutes;
